import React from "react";
import { useLocation } from "react-router-dom";
import { TaskSummary } from "@common/types/task";
import { StateAwareNavLink } from "@components/routes/StateAwareNavLink";
import styles from "./ChatTaskAuditLog.module.scss";

interface SearchWithParamsArgs {
    search: string;
    params: string;
}

// Opens a task on the page the reader is on: the current filters stay and only
// the params of the link (taskId, and taskWorkspaceId when given) change.
export function searchWithParams({
    search,
    params,
}: SearchWithParamsArgs): string {
    const next = new URLSearchParams(search);
    for (const [key, value] of new URLSearchParams(params)) {
        next.set(key, value);
    }
    return `?${next.toString()}`;
}

interface Props {
    summaries: TaskSummary[];
}

export const TaskSummaryLinks: React.FC<Props> = ({ summaries }) => {
    const { search } = useLocation();

    return summaries.map((summary, index) => (
        <React.Fragment key={summary.id}>
            {index === 0 ? null : ", "}
            <StateAwareNavLink
                to={{
                    search: searchWithParams({
                        search,
                        params: `taskId=${summary.id}`,
                    }),
                }}
                replace
                className={styles.taskLink}
            >
                {summary.title}
            </StateAwareNavLink>
        </React.Fragment>
    ));
};
